export const debounce = (func: (...args: never[]) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: never[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
